import React from 'react'

const getInitialTheme: () => string = () => {
  // Siempre retornar 'light' por defecto al ingresar al sistema
  // Ignorando localStorage y preferencias del sistema
  return 'light'
}

export const ThemeContext = React.createContext<ThemeContextType>(
  {} as ThemeContextType
)

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = React.useState<string>(getInitialTheme)

  const rawSetTheme = (rawTheme: string) => {
    const root = window.document.documentElement
    console.log('ROOT', root)
    const isDark = rawTheme === 'dark'

    root.classList.remove(isDark ? 'light' : 'dark')
    root.classList.add(rawTheme.replaceAll(' ', ''))

    localStorage.setItem('color-theme', rawTheme)
    setTheme(rawTheme)
  }

  // Inicialización: limpiar cualquier clase dark previa y forzar light
  React.useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove('dark')
    root.classList.add('light')
    rawSetTheme('light')
  }, [])

  React.useEffect(() => {
    rawSetTheme(theme)
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

type ThemeContextType = {
  theme: string
  setTheme: (Theme: string) => void
}

// type ThemeProviderProps = {
//     children;
//     initialTheme?: 'light' | 'dark';
// }
